export const ADMIN_PROFILE = 'adminProfile';
export const ACCOUNT_GOOGLE_LIST = 'accountGoogleList';
export const SCHEDULE_MANAGEMENT = 'scheduleManagement';
export const BOOKING_MANAGEMENT = 'bookingManagement';
export const CONFIG_LOGO = 'configLogo';
export const LOCATION = 'location';
export const LOCATION_LIST = 'locationList';
export const REPORT_API = 'reportApi';
export const APPLICATION_API = 'application-api';
export const APPROVAL_API = 'approval-api';
export const LEAVE_REGULATION_API = 'leave-regulation-api';
export const SETTING_MESSAGE = 'settingMessage';
export const LINE_GROUPS = 'lineGroups';
export const GENERAL_CONFIG_API = 'general-config-api';
export const LOCATION_GROUPS = 'locationGroups';
export const WORK_HOURS = 'workHours';
export const DAY_START = 'dayStart';
export const TIME_API = 'time-api';
export const HOLIDAY_API = 'holiday-api';
export const OVERTIME_API = 'holiday-api';
export const RECRUITMENT_API = 'recruitment-api';
export const TIME_KEEPING_API = 'time-keeping-api';
export const TIME_KEEPING_HISTORY_STATISTIC = 'time-keeping-history-static';
export const CONFIRMATION_API = 'confirmation-api';
export const EMPLOYEE_APPLICATION = 'employee-application';
export const ATTENDANCE_MANAGEMNT_API = 'attendance-management-api';
export const OUT_OF_YEAR_MANAGEMENT = 'out-of-year-management';
export const OVERTIME_SATISTIC = 'overtime-statistic';
export const DEFAULT_WORK_HOURS_BY_RECRUITMENT_TYPE = 'default-work-hour-by-type';
export const QUERY_KEY = {
  USER_LIST: 'USER_LIST',
  USER_BY_ID: 'USER_BY_ID',
  USER_RELATED_INFORMATION: 'USER_RELATED_INFORMATION',
  USER_TYPE_LIST: 'USER_TYPE_LIST',
  POSITION_MANAGEMENT: 'POSITION_MANAGEMENT',
  DEPARTMENT_MANAGEMENT: 'DEPARTMENT_MANAGEMENT',
  EMPLOYEE_LIST: 'EMPLOYEE_LIST',
  SELECT_LIST: 'SELECT_LIST',
  CATEGORY: 'CATEGORY',
  OPTIONS_SETTING: 'OPTIONS_SETTING',
  TIME_API: 'TIME_API',
  WORKING_SCHEDULE: 'WORKING_SCHEDULE',
  OVERTIME_API: 'OVERTIME_API',
  DATA_IMPORT_TABLE: 'DATA_IMPORT_TABLE',
  TIMEKEEPING_REMINDER: 'TIMEKEEPING_REMINDER',
  LINE_GROUP_LIST: 'LINE_GROUP_LIST',
  SCHEDULES: 'SCHEDULES',
  TRANSFER_EMPLOYEES_CALENDAR: 'TRANSFER_EMPLOYEES_CALENDAR',
};
